export default __webpack_public_path__ + "static/media/blockchainbanner.04bfb930.png";